<nav
  class="mobile-bottom-nav"
  [class.entrance]="isEntrance()"
>
  <button
    mat-button
    class="nav-button"
    [routerLink]="todayRoute"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    [attr.aria-label]="T.G.TODAY_TAG_TITLE | translate"
  >
    <mat-icon>wb_sunny</mat-icon>
  </button>
  @if (isPlannerEnabled()) {
    <button
      mat-button
      class="nav-button"
      routerLink="/planner"
      routerLinkActive="active"
      [attr.aria-label]="T.MH.PLANNER | translate"
    >
      <mat-icon>edit_calendar</mat-icon>
    </button>
  }
  <button
    mat-fab
    class="add-task-button"
    [class.smaller]="hasProjectBacklog()"
    color="primary"
    (click)="showAddTaskBar()"
    [attr.aria-label]="T.GCF.KEYBOARD.GLOBAL_ADD_TASK | translate"
  >
    <mat-icon>add</mat-icon>
  </button>

  @if (sidePanelItemCount() === 1) {
    <!-- A menu with a single entry is just an extra tap: show the entry itself. -->
    @if (sidePanelButtons()[0]; as button) {
      <button
        mat-button
        class="nav-button"
        [class.active]="activePluginId() === button.pluginId && isShowPluginPanel()"
        [attr.aria-pressed]="activePluginId() === button.pluginId && isShowPluginPanel()"
        (click)="onPluginButtonClick(button)"
        [attr.aria-label]="button.label"
      >
        <plugin-icon
          [pluginId]="button.pluginId"
          [fallbackIcon]="button.icon || 'extension'"
        ></plugin-icon>
      </button>
    } @else if (isScheduleDayPanelEnabled()) {
      <button
        mat-button
        class="nav-button e2e-toggle-schedule-day-panel"
        [class.active]="isShowScheduleDayPanel()"
        [attr.aria-pressed]="isShowScheduleDayPanel()"
        (click)="toggleScheduleDayPanel()"
        [attr.aria-label]="T.BN.SHOW_SCHEDULE | translate"
      >
        <mat-icon>schedule</mat-icon>
      </button>
    } @else if (isIssuesPanelEnabled()) {
      <button
        mat-button
        class="nav-button e2e-toggle-issue-provider-panel"
        [class.active]="isShowIssuePanel()"
        [attr.aria-pressed]="isShowIssuePanel()"
        (click)="toggleIssuePanel()"
        [attr.aria-label]="T.BN.SHOW_ISSUE_PANEL | translate"
      >
        <mat-icon>webhook</mat-icon>
      </button>
    } @else if (isProjectNotesEnabled()) {
      <button
        mat-button
        class="nav-button e2e-toggle-notes-btn"
        [class.active]="isShowNotes()"
        [attr.aria-pressed]="isShowNotes()"
        (click)="toggleNotes()"
        [attr.aria-label]="T.BN.SHOW_NOTES | translate"
      >
        <mat-icon>comment</mat-icon>
      </button>
    }
  } @else if (sidePanelItemCount() > 1) {
    <button
      mat-button
      class="nav-button"
      [matMenuTriggerFor]="panelsMenu"
      [attr.aria-label]="T.MH.SIDE_PANEL_MENU | translate"
    >
      <mat-icon>bottom_panel_open</mat-icon>
    </button>
  }

  <button
    mat-button
    class="nav-button"
    (click)="toggleMobileNav()"
    [attr.aria-label]="T.MH.PROJECT_MENU | translate"
  >
    <mat-icon>menu</mat-icon>
  </button>
</nav>

<mat-menu
  #panelsMenu="matMenu"
  class="mobile-bottom-nav-panels-menu"
>
  @for (button of sidePanelButtons(); track button.pluginId) {
    <button
      mat-menu-item
      (click)="onPluginButtonClick(button)"
      [class.active]="activePluginId() === button.pluginId && isShowPluginPanel()"
    >
      <plugin-icon
        [pluginId]="button.pluginId"
        [fallbackIcon]="button.icon || 'extension'"
      ></plugin-icon>
      <span>{{ button.label }}</span>
    </button>
  }

  @if (isScheduleDayPanelEnabled()) {
    <button
      mat-menu-item
      class="e2e-toggle-schedule-day-panel"
      [class.active]="isShowScheduleDayPanel()"
      (click)="toggleScheduleDayPanel()"
    >
      <mat-icon>schedule</mat-icon>
      <span>{{ T.BN.SHOW_SCHEDULE | translate }}</span>
    </button>
  }

  @if (isIssuesPanelEnabled()) {
    <button
      mat-menu-item
      class="e2e-toggle-issue-provider-panel"
      [class.active]="isShowIssuePanel()"
      (click)="toggleIssuePanel()"
    >
      <mat-icon>webhook</mat-icon>
      <span>{{ T.BN.SHOW_ISSUE_PANEL | translate }}</span>
    </button>
  }

  @if (isProjectNotesEnabled()) {
    <button
      mat-menu-item
      class="e2e-toggle-notes-btn"
      [class.active]="isShowNotes()"
      (click)="toggleNotes()"
    >
      <mat-icon>comment</mat-icon>
      <span>{{ T.BN.SHOW_NOTES | translate }}</span>
    </button>
  }
</mat-menu>
